const productSuggestion = 5

export const fetchRecomendationParticipant = (participantId, identifier) => ({
  type: 'FETCH_PRODUCT_RECOMENDATION',
  participantId,
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v2/showcases/${productSuggestion}?identifier=${identifier}&cachedPrice=true`
    }
  }
})

export const fetchRecomendationSku = (productId, identifier) => ({
  type: 'FETCH_PRODUCT_RECOMENDATION',
  productId,
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v2/showcases/${productSuggestion}?identifier=${identifier}&cachedPrice=true`
    }
  }
})

export const fetchAvailability = (sku, vendorId, originalId) => ({
  type: 'FETCH_RECOMENDATION_AVAILABILITY',
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v1/products/skus/${sku}/availability?vendorId=${vendorId}&originalId=${originalId}`
    }
  }
})



// WEBPACK FOOTER //
// ./src/features/Suggestion/ProductRecomendation/actions.js